import { QueueSupervisorDTO } from "./QueueSupervisorDTO";
import { SupervisorQueueAgentDTO } from "./SupervisorQueueAgentDTO";

export class SupervisorProcessDTO {
    Agents!:SupervisorQueueAgentDTO[];
    Queues!:QueueSupervisorDTO[];
}
